import { RUN_STATUS } from '@/constants/analyst-constants';

/**
 * Check if any of the provided agent runs are in a RUNNING state
 *
 * @param {Array} runs - List of agent run objects
 * @returns {boolean} - True if any run is running, false otherwise
 */
export function hasAgentRunInProgress(runs) {
  return runs ? runs.some((run) => run.status === RUN_STATUS.RUNNING) : false;
}

/**
 * Get the latest agent run from a list of runs
 *
 * @param {Array} runs - List of agent run objects
 * @returns {Object|null} - The latest run or null if no runs exist
 */
export function getLatestAgentRun(runs) {
  return runs?.length > 0 ? runs[runs.length - 1] : null;
}
